// A "list scope" says whether a list/detail screen shows site-wide records
// ('all') or only the signed-in user's records ('mine'). Shared screens take a
// `scope` prop and read every scope-dependent path and label from here, so the
// All and My variants of a screen can't drift apart.
//
// "My" URLs carry no user id — the signed-in user is identified by the auth
// cookie on every API request, never by the URL.
export const SCOPE_ALL = 'all';
export const SCOPE_MINE = 'mine';

const SCOPES = {
  [SCOPE_ALL]: build(false, '/all_benchmarks', '/all_drives'),
  [SCOPE_MINE]: build(true, '/me/benchmarks', '/me/drives'),
};

function build(mine, benchmarksPath, drivesPath) {
  return {
    mine,
    benchmarksPath,
    drivesPath,
    benchmarkPath: (benchmarkId) => `${benchmarksPath}/benchmark/${benchmarkId}`,
    drivePath: (driveId) => `${drivesPath}/drive/${driveId}`,
    benchmarksLabel: mine ? 'My Benchmarks' : 'Benchmarks',
    drivesLabel: mine ? 'My Drives' : 'Drives',
  };
}

export function getListScope(scope = SCOPE_ALL) {
  return SCOPES[scope] ?? SCOPES[SCOPE_ALL];
}

// Hook form kept so screens read naturally; scopes are static.
export function useListScope(scope = SCOPE_ALL) {
  return getListScope(scope);
}
